export const autoinformer = {
  name: 'autoinformer',
  title: 'autoinformer.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-informer.vue'),
  route: { name: 'autoinformer.module' },
  children: [
    {
      title: 'autoinformer.breadcrumb.campaign.index',
      route: { name: 'autoinformer.campaign.index' },
      routes: [{ name: 'autoinformer.campaign.new' }]
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'autoinformer.stats.type', params: { type: 'detailed' } }
    }
  ]
};
